import { Box, Typography } from '@mui/material'
import { useContext } from 'react'

import Button from '@/components/base/Button'
import useNemoWallet from '@/hooks/use-nemo-wallet'
import useTrans from '@/hooks/useTrans'

import { WrappedTokensFlowContext } from '../context'

type FlowConnectWalletProps = {
  onClick: () => void
}

const FlowConnectWallet = ({ onClick }: FlowConnectWalletProps) => {
  const trans = useTrans()
  const { connectWallet } = useNemoWallet()
  const { selectedToken } = useContext(WrappedTokensFlowContext)

  const handleClick = () => {
    connectWallet()
    onClick()
  }

  if (!selectedToken) return null

  return (
    <Box>
      <Typography className="text-sm font-semibold mb-[24px]">{trans.wrapped_token.you_can_trade(selectedToken.displaySymbol)}</Typography>
      <Button
        onClick={handleClick}
        variant="outlined"
        size="xl"
        fullWidth
        data-testid="flow-connect-token-btn"
      >
        <span className="text-gradient">{trans.common.connect_wallet}</span>
      </Button>
    </Box>
  )
}

export default FlowConnectWallet
